module.exports = __webpack_public_path__ + "img/step1-3.2180d46c.png";